import { render, staticRenderFns } from "./RiskRatingAdaptationChart.vue?vue&type=template&id=65d674fb&"
import script from "./RiskRatingAdaptationChart.vue?vue&type=script&lang=js&"
export * from "./RiskRatingAdaptationChart.vue?vue&type=script&lang=js&"
import style0 from "./RiskRatingAdaptationChart.vue?vue&type=style&index=0&id=65d674fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports